import React, { useEffect, useState, useRef, createElement, Component } from 'react';
import { cn } from '@/lib/utils';
import { useMotionValue, useTransform, animate } from 'framer-motion';
import { CheckCircle2, Star, Heart, CreditCard, Users, Ticket, ArrowRight, MessageCircle, X, ThumbsUp, GraduationCap, Zap, ShieldCheck, Flower2, Leaf, Sparkles, Medal } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
// --- Types ---
declare global {
  interface Window {
    fbq: any;
  }
}
// --- Constants & Data ---
const CHECKOUT_URL = 'https://novalibros.shop/cart/48530262130937:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/npQgkL51ifKiAYU7NpRrzU/COSMETICA_VIVA_PNG.png';
const BONUSES = [{
  id: 1,
  img: 'https://cdn.magicpatterns.com/uploads/gupmjWjTaHKzvZynE789Sc/BONO_1_LIBRO.png',
  title: 'Cabello Vivo',
  description: 'Fórmulas naturales para un cabello fuerte, brillante y saludable desde la raíz.'
}, {
  id: 2,
  img: 'https://cdn.magicpatterns.com/uploads/xmxtvNAwGKzxKNY9ifZECj/BONO_2_LIBRO.png',
  title: 'Maquillaje Vivo',
  description: 'Crea tu propio maquillaje mineral y natural libre de tóxicos y químicos pesados.'
}, {
  id: 3,
  img: 'https://cdn.magicpatterns.com/uploads/edw9sA2n6EFLQRzRR6xmdC/BONO_3_LIBRO.png',
  title: 'Shampoo Vivo',
  description: 'Domina el arte del shampoo sólido y líquido adaptado a cada tipo de necesidad.'
}, {
  id: 4,
  img: 'https://cdn.magicpatterns.com/uploads/b47Fkrfh6L5z3dXV1py2kg/BONO_4_LIBRO.png',
  title: 'Perfumes Capilares',
  description: 'Fragancias botánicas que refrescan, cuidan y embellecen tu cabello todo el día.'
}, {
  id: 5,
  img: 'https://cdn.magicpatterns.com/uploads/kJTxrUCwgBoc3JNdXJjDDa/BONO_5_LIBRO.png',
  title: 'Protección Natural',
  description: 'Elabora tus propios protectores solares y pastas dentales 100% biodegradables.'
}, {
  id: 6,
  img: 'https://cdn.magicpatterns.com/uploads/vs3CEyEMj6qzDcdTCyNe5f/BONO_6_LIBRO.png',
  title: 'Alivio Natural',
  description: 'Ungüentos y pomadas artesanales para calmar dolores y cuidar la piel de tu familia.'
}, {
  id: 7,
  img: 'https://cdn.magicpatterns.com/uploads/hsHYxByebbeN3LRkzf3GYC/BONO_7_LIBRO.png',
  title: 'Mirada Viva',
  description: 'Fortalece y embellece tus pestañas y cejas con sérums botánicos de alto impacto.'
}, {
  id: 8,
  img: 'https://cdn.magicpatterns.com/uploads/2KMF1pLfoas2dhC79MqwQp/BONO_8_LIBRO.png',
  title: 'Modelado Capilar',
  description: 'Geles y cremas de peinar naturales para definir tus rizos y controlar el frizz.'
}];
const INITIAL_TESTIMONIALS = [{
  id: 1,
  name: 'Carmen G.',
  city: 'Rosario',
  text: 'Tengo 57 años y nunca había preparado nada cosmético. Empecé con la crema de noche y me encantó el resultado. Me dejó la piel suave y sin sensación grasosa. es mas facil de lo que pensaba',
  rating: 5,
  likes: 12,
  date: 'hace 2 horas',
  avatar: 'https://cdn.magicpatterns.com/uploads/dkg7hcEgmf515qUh6TPz3Z/image.png'
}, {
  id: 2,
  name: 'Mariela',
  city: 'Córdoba',
  text: 'estaba re perdida con los ingredientes pero la guia te explica todo paso a paso. ya tengo mis primeros balsamos listos para regalar en navidad!',
  rating: 5,
  likes: 8,
  date: 'hace 5 horas',
  avatar: 'https://cdn.magicpatterns.com/uploads/sdoqWXDaGMnsENyXGeSq86/image.png'
}, {
  id: 3,
  name: 'maria mercedes',
  city: 'Buenos Aires',
  text: 'Me encanto el enfoque natural. Al principio dudaba xq no sabia nada de quimica pero es super amigable. 100% recomendado',
  rating: 4,
  likes: 15,
  date: 'hace 1 día',
  avatar: 'https://cdn.magicpatterns.com/uploads/nUE7i5ETko2duvdpTJT47c/image.png'
}, {
  id: 4,
  name: 'Pato',
  city: 'Mendoza',
  text: 'la verdad q x el precio es un regalo. los bonos estan buenisimos tmb. el de shampoo me cambio el pelo mal',
  rating: 5,
  likes: 21,
  date: 'hace 2 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/kWofqSLbVTbMnCwQq668SF/image.png'
}, {
  id: 5,
  name: 'Vane',
  city: 'Salta',
  text: 'ya empece a vender mis propios tonicos a mis amigas y estan chochas. una oportunidad de oro para arrancar algo propio',
  rating: 5,
  likes: 34,
  date: 'hace 3 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/mTKorJuksAvzwCUDpa41vU/image.png'
}];
const ARG_CITIES = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'Salta', 'Tucumán', 'La Plata', 'Mar del Plata', 'Neuquén', 'Posadas'];
const ARG_NAMES = ['María', 'Florencia', 'Agustina', 'Lucía', 'Camila', 'Valentina', 'Martina', 'Paula', 'Silvia', 'Gabriela'];
// --- Components ---
const Button = ({
  children,
  className = '',
  onClick,
  showShine = false
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  showShine?: boolean;
}) => <button onClick={onClick || (() => window.location.href = CHECKOUT_URL)} className={`w-full py-4 px-6 rounded-xl font-bold text-lg transition-all transform hover:scale-105 active:scale-95 shadow-lg flex items-center justify-center gap-2 relative overflow-hidden ${className}`} data-id="element-0">
    {showShine && <motion.div initial={{
    x: '-150%'
  }} animate={{
    x: '150%'
  }} transition={{
    repeat: Infinity,
    duration: 2.5,
    ease: 'linear',
    repeatDelay: 3
  }} className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] pointer-events-none" data-id="element-1" />}
    <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-2">
      {children}
    </span>
  </button>;
const Counter = ({
  target,
  duration
}: {
  target: number;
  duration: number;
}) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, latest => {
    const val = Math.round(latest);
    return val >= 1000 ? `+${val.toLocaleString('de-DE')}` : `+${val}`;
  });
  useEffect(() => {
    const controls = animate(count, target, {
      duration
    });
    return controls.stop;
  }, [count, target, duration]);
  return <motion.span data-id="element-3">{rounded}</motion.span>;
};
const Section = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => <section className={cn(`py-12 px-6 max-w-4xl mx-auto ${className}`, 'pt-[9px] pb-[9px]', 'pt-[0px] pb-[0px] mt-[0px] mb-[0px]')} data-id="element-4">
    {children}
  </section>;
const CountdownText = () => {
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <span className="text-sm font-black text-[#9D4D60] tabular-nums" data-id="element-5">
      {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
    </span>;
};
export function App() {
  const [selectedOffer, setSelectedOffer] = useState('premium');
  const [coupons, setCoupons] = useState(13);
  const [viewers, setViewers] = useState(48);
  const [purchaseNotify, setPurchaseNotify] = useState<{
    name: string;
    city: string;
  } | null>(null);
  const [comments, setComments] = useState(INITIAL_TESTIMONIALS);
  const [studentCount, setStudentCount] = useState(1101);
  const [newComment, setNewComment] = useState('');
  const [newRating, setNewRating] = useState(5);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [visibleComments, setVisibleComments] = useState(5);
  const [showSticky, setShowSticky] = useState(false);
  const [stickyInfoIndex, setStickyInfoIndex] = useState(0);
  const purchaseSectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // --- Meta Pixel Code ---
    const pixelId = '2633544103706749';
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = window.fbq;
      window.fbq.push = window.fbq;
      window.fbq.loaded = !0;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      window.fbq('init', pixelId);
    }
    window.fbq('track', 'PageView');
    // --- End Meta Pixel Code ---
    const couponInterval = setInterval(() => {
      setCoupons(prev => prev > 2 ? prev - 1 : prev);
    }, 45000);
    const viewerInterval = setInterval(() => {
      setViewers(Math.floor(Math.random() * (55 - 35 + 1)) + 35);
    }, 10000);
    const notifyInterval = setInterval(() => {
      const name = ARG_NAMES[Math.floor(Math.random() * ARG_NAMES.length)];
      const city = ARG_CITIES[Math.floor(Math.random() * ARG_CITIES.length)];
      setPurchaseNotify({
        name,
        city
      });
      setTimeout(() => setPurchaseNotify(null), 5000);
    }, 15000);
    const studentInterval = setInterval(() => {
      setStudentCount(prev => prev + 1);
    }, 30000);
    const stickyInterval = setInterval(() => {
      setStickyInfoIndex(prev => prev === 0 ? 1 : 0);
    }, 4000);
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearInterval(couponInterval);
      clearInterval(viewerInterval);
      clearInterval(notifyInterval);
      clearInterval(studentInterval);
      clearInterval(stickyInterval);
    };
  }, []);
  const scrollToPurchase = () => {
    purchaseSectionRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handlePostComment = () => {
    if (!newComment.trim()) return;
    const comment = {
      id: Date.now(),
      name: 'Usuario',
      city: 'Argentina',
      text: newComment,
      rating: newRating,
      likes: 0,
      date: 'ahora mismo'
    };
    setComments([comment, ...comments]);
    setNewComment('');
    setShowSuccessModal(true);
  };
  const today = new Date().toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  return <div className="min-h-screen bg-[#FDF2F2] text-slate-800 overflow-x-hidden" data-id="element-6">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-7">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2633544103706749&ev=PageView&noscript=1" alt="" data-id="element-8" />
      </noscript>

      {/* Trust Banner */}
      <div className="bg-white/40 border-b border-pink-100 py-1.5" data-id="element-9">
        <div className="max-w-4xl mx-auto px-4 flex flex-nowrap whitespace-nowrap text-[7px] md:text-[9px] font-semibold uppercase tracking-[0.2em] text-[#9D4D60] items-center justify-center md:gap-6 gap-[2px]" data-id="element-10">
          <div className="flex items-center gap-1" data-id="element-11">
            <GraduationCap size={10} className="text-[#D4AF37]" data-id="element-12" />
            <span data-id="element-13">
              <Counter target={1000} duration={5} data-id="element-14" /> Alumnos
            </span>
          </div>

          <Flower2 size={8} className="text-[#D4AF37] opacity-40" data-id="element-15" />

          <div className="flex items-center gap-1" data-id="element-16">
            <Zap size={10} className="text-[#D4AF37]" data-id="element-17" />
            <span data-id="element-18">Acceso Inmediato</span>
          </div>

          <Flower2 size={8} className="text-[#D4AF37] opacity-40" data-id="element-19" />

          <div className="flex items-center gap-1" data-id="element-20">
            <ShieldCheck size={10} className="text-[#D4AF37]" data-id="element-21" />
            <span data-id="element-22">Garantía 7 Días</span>
          </div>
        </div>
      </div>

      {/* Header */}

      {/* Validity Banner */}

      {/* Hero Section */}
      <Section className="text-center pt-12 pb-8" data-id="element-23">
        <div className="pt-[7px] pb-[7px] mt-[3px] mb-[3px]" data-id="element-24">
          <h1 className="text-xs md:text-sm font-bold tracking-[0.4em] mb-2 text-[#9D4D60] opacity-80" data-id="element-25">
            BIENVENIDA A
          </h1>
          <div className="relative inline-block" data-id="element-26">
            <span className="text-3xl md:text-5xl font-serif font-bold tracking-tight bg-gradient-to-r from-[#B76E79] via-[#E1B1B9] to-[#D4AF37] bg-clip-text text-transparent animate-pulse" data-id="element-27">
              COSMÉTICA VIVA
            </span>
            <div className="absolute -top-2 -right-4 text-[#D4AF37] animate-bounce" data-id="element-28">
              ✨
            </div>
            <div className="absolute -bottom-1 -left-2 text-[#D4AF37] animate-pulse delay-700" data-id="element-29">
              ✨
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center opacity-60 pt-[0px] pb-[0px] mt-[9px] mb-[9px] gap-[16px]" data-id="element-30">
          <div className="h-[1px] w-8 bg-[#2D5A27]" data-id="element-31"></div>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#2D5A27] font-semibold" data-id="element-32">
            Tu momento es ahora
          </span>
          <div className="h-[1px] w-8 bg-[#2D5A27]" data-id="element-33"></div>
        </div>
        <h2 className="text-2xl md:text-3xl font-serif italic text-[#2D5A27] leading-tight max-w-2xl mx-auto pt-[0px] pb-[0px] mt-[0px] mb-[0px] tracking-tight" data-id="element-34">
          Más de{' '}
          <span className="text-[#9D4D60] font-bold not-italic" data-id="element-35">
            300 recetas
          </span>{' '}
          para crear <br className="hidden md:block" data-id="element-36" />
          cosmética natural desde casa.
        </h2>

        <div className="mb-6 cursor-pointer relative max-w-md mx-auto group" onClick={scrollToPurchase} data-id="element-37">
          {/* Subtle Floral Decorations */}
          <div className="absolute inset-0 pointer-events-none z-0" data-id="element-38">
            <motion.div animate={{
            y: [0, -15, 0],
            rotate: [0, 10, 0],
            opacity: [0.3, 0.6, 0.3]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -top-6 -left-4 text-[#B76E79]" data-id="element-39">
              <Flower2 size={28} strokeWidth={1.5} data-id="element-40" />
            </motion.div>

            <motion.div animate={{
            y: [0, 15, 0],
            rotate: [0, -15, 0],
            opacity: [0.2, 0.5, 0.2]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute top-1/4 -right-6 text-[#2D5A27]" data-id="element-41">
              <Leaf size={24} strokeWidth={1.5} data-id="element-42" />
            </motion.div>

            <motion.div animate={{
            scale: [1, 1.2, 1],
            opacity: [0.2, 0.4, 0.2]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.5
          }} className="absolute bottom-1/4 -left-8 text-[#D4AF37]" data-id="element-43">
              <Sparkles size={20} data-id="element-44" />
            </motion.div>

            <motion.div animate={{
            y: [0, -10, 0],
            rotate: [0, 20, 0],
            opacity: [0.3, 0.6, 0.3]
          }} transition={{
            duration: 7,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 2
          }} className="absolute -bottom-4 right-4 text-[#E1B1B9]" data-id="element-45">
              <Flower2 size={22} strokeWidth={1.5} data-id="element-46" />
            </motion.div>

            <motion.div animate={{
            rotate: [0, 10, 0],
            x: [0, 5, 0]
          }} transition={{
            duration: 8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute bottom-1/2 -right-4 text-[#2D5A27] opacity-20" data-id="element-47">
              <Leaf size={18} strokeWidth={1} data-id="element-48" />
            </motion.div>
          </div>

          <motion.img initial={{
          y: 0
        }} animate={{
          y: [0, -12, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} src={MAIN_IMAGE} alt="Cosmética Viva Libro" className="w-full relative z-10 hover:scale-[1.05] transition-all duration-500 drop-shadow-[0_25px_45px_rgba(183,110,121,0.25)] pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-49" />
        </div>

        <div className="max-w-xl mx-auto mb-10" data-id="element-50">
          <p className="md:text-[12px] font-medium text-[#2D5A27] uppercase tracking-[0.35em] opacity-95 text-[12px]" data-id="element-51">
            Transformá{' '}
            <span className="text-[#9D4D60] font-black" data-id="element-52">
              ingredientes naturales
            </span>{' '}
            en productos que <br data-id="element-53" />
            <span className="text-[#D4AF37] font-black italic" data-id="element-54">
              cuidan tu piel
            </span>{' '}
            y despiertan tu{' '}
            <span className="text-[#9D4D60] font-black" data-id="element-55">creatividad</span>.
          </p>
        </div>
      </Section>

      {/* Section Separator */}
      <div className="flex items-center justify-center py-4 opacity-30" data-id="element-56">
        <div className="h-px w-12 bg-[#D4AF37]" data-id="element-57" />
        <Flower2 size={16} className="mx-4 text-[#D4AF37]" data-id="element-58" />
        <div className="h-px w-12 bg-[#D4AF37]" data-id="element-59" />
      </div>

      {/* Problem Section with Comparison Table */}
      <Section className="my-16" data-id="element-60">
        <div className="text-center mb-10" data-id="element-61">
          <div className="relative inline-block overflow-hidden" data-id="element-62">
            <p className="font-bold text-[#9D4D60] uppercase tracking-[0.2em] text-xs relative z-10 pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-63">
              Antes de Cosmética Viva, muchas personas se encontraban con esto
            </p>
            <motion.div initial={{
            x: '-100%'
          }} animate={{
            x: '200%'
          }} transition={{
            repeat: Infinity,
            duration: 3,
            ease: 'linear',
            repeatDelay: 2
          }} className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-20deg] z-20 pointer-events-none" data-id="element-64" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-65">
          {/* Cons Column */}
          <div className="border border-red-100 rounded-[2rem] p-8 space-y-6 relative overflow-hidden group bg-[#F8E5E5]" data-id="element-66">
            <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-67">
              <X size={80} className="text-red-500" data-id="element-68" />
            </div>
            <h4 className="font-serif text-xl text-red-700 font-bold flex items-center gap-2" data-id="element-69">
              <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center" data-id="element-70">
                <X size={16} className="text-red-500" data-id="element-71" />
              </div>
              Sin una guía clara
            </h4>
            <ul className="space-y-4 text-sm md:text-base text-red-900/70" data-id="element-72">
              <li className="flex items-start gap-3" data-id="element-73">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-74" />
                Recetas incompletas y confusas de internet.
              </li>
              <li className="flex items-start gap-3" data-id="element-75">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-76" />
                Videos contradictorios que te generan dudas.
              </li>
              <li className="flex items-start gap-3" data-id="element-77">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-78" />
                Ingredientes que no conocés ni sabés usar.
              </li>
              <li className="flex items-start gap-3" data-id="element-79">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-80" />
                Cantidades confusas que arruinan tus mezclas.
              </li>
            </ul>
          </div>

          {/* Pros Column */}
          <div className="bg-[#2D5A27]/5 border border-[#2D5A27]/10 rounded-[2rem] p-8 space-y-6 relative overflow-hidden group shadow-sm" data-id="element-81">
            <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-82">
              <Leaf size={80} className="text-[#2D5A27]" data-id="element-83" />
            </div>
            <h4 className="font-serif text-xl text-[#2D5A27] font-bold flex items-center gap-2" data-id="element-84">
              <div className="w-8 h-8 rounded-full bg-[#2D5A27]/10 flex items-center justify-center" data-id="element-85">
                <CheckCircle2 size={16} className="text-[#2D5A27]" data-id="element-86" />
              </div>
              Con Cosmética Viva
            </h4>
            <ul className="space-y-4 text-sm md:text-base text-[#2D5A27]/80" data-id="element-87">
              <li className="flex items-start gap-3" data-id="element-88">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-89" />
                Guía digital completa, simple y organizada.
              </li>
              <li className="flex items-start gap-3" data-id="element-90">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-91" />
                Paso a paso detallado para cada producto.
              </li>
              <li className="flex items-start gap-3" data-id="element-92">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-93" />
                Fundamentos reales sobre ingredientes.
              </li>
              <li className="flex items-start gap-3" data-id="element-94">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-95" />
                Confianza total al crear tus propias fórmulas.
              </li>
            </ul>
          </div>
        </div>
      </Section>

      {/* Solution Section */}
      <Section className="relative overflow-hidden" data-id="element-96">
        {/* Subtle Background Decoration */}
        <div className="absolute top-0 right-0 opacity-5 pointer-events-none -mr-20 -mt-20" data-id="element-97">
          <Flower2 size={300} className="text-[#B76E79]" data-id="element-98" />
        </div>

        <div className="text-center mb-16 relative z-10" data-id="element-99">
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-[#2D5A27] mb-6 leading-tight pt-[14px] pb-[14px]" data-id="element-100">
            Cosmética Viva es una <br className="hidden md:block" data-id="element-101" />
            <span className="bg-gradient-to-r from-[#B76E79] to-[#D4AF37] bg-clip-text text-transparent" data-id="element-102">
              guía digital completa
            </span>
          </h3>
          <div className="w-24 h-[1px] bg-[#D4AF37]/30 mx-auto mb-6" data-id="element-103"></div>
          <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto italic font-serif pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-104">
            "Te enseña a elaborar cosmética natural de forma simple,{' '}
            <br className="hidden md:block" data-id="element-105" />
            práctica y profundamente organizada."
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16 relative z-10" data-id="element-106">
          <div className="bg-white/60 backdrop-blur-sm p-8 md:p-10 rounded-[2.5rem] shadow-xl shadow-pink-100/20 border border-pink-50 relative group" data-id="element-107">
            <div className="absolute -top-4 -left-4 bg-[#D4AF37] text-white p-3 rounded-2xl shadow-lg transform -rotate-12 group-hover:rotate-0 transition-transform duration-500" data-id="element-108">
              <Sparkles size={24} data-id="element-109" />
            </div>
            <h4 className="font-serif italic text-[#2D5A27] mb-8 text-2xl border-b border-[#2D5A27]/10 pb-4" data-id="element-110">
              ¿Qué vas a aprender?
            </h4>
            <ul className="grid grid-cols-1 gap-4" data-id="element-111">
              {['Cremas faciales y corporales', 'Sérums naturales', 'Tónicos faciales', 'Exfoliantes', 'Mascarillas', 'Bálsamos labiales', 'Perfumes naturales', 'Desodorantes naturales', 'Aceites corporales', 'Fórmulas antiedad', 'Maquillaje Natural', 'Protectores Solares', 'Sérums y Máscara de Pestañas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-slate-700 group/item" data-id="element-112">
                  <div className="w-6 h-6 rounded-full bg-[#2D5A27]/5 flex items-center justify-center group-hover/item:bg-[#2D5A27]/10 transition-colors" data-id="element-113">
                    <Leaf size={12} className="text-[#2D5A27]" data-id="element-114" />
                  </div>
                  <span className="text-sm md:text-base font-medium tracking-wide" data-id="element-115">
                    {item}
                  </span>
                </li>)}
            </ul>
            <div className="mt-8 pt-6 border-t border-[#D4AF37]/10" data-id="element-116">
              <p className="text-[#D4AF37] font-bold tracking-widest uppercase text-xs flex items-center gap-2" data-id="element-117">
                <Sparkles size={14} data-id="element-118" /> Y mucho más por descubrir
              </p>
            </div>
          </div>

          <div className="flex flex-col justify-center space-y-8" data-id="element-119">
            <div className="space-y-6" data-id="element-120">
              {[{
              title: 'Sin experiencia previa',
              text: 'Aunque nunca hayas hecho una crema en tu vida.'
            }, {
              title: 'Paso a paso real',
              text: 'Aunque no tengas conocimientos de ingredientes o Formulación.'
            }, {
              title: 'Tu propio ritmo',
              text: 'Acceso de por vida para que aprendas cuando vos quieras.'
            }].map((item, i) => <div key={i} className="flex gap-5 items-start group" data-id="element-121">
                  <div className="w-12 h-12 rounded-2xl bg-white shadow-md flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300 border border-pink-50" data-id="element-122">
                    <Heart size={20} className="text-[#9D4D60]" data-id="element-123" />
                  </div>
                  <div data-id="element-124">
                    <h5 className="font-bold text-[#2D5A27] text-lg mb-1" data-id="element-125">
                      {item.title}
                    </h5>
                    <p className="text-slate-500 leading-relaxed text-sm md:text-base" data-id="element-126">
                      {item.text}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="max-w-md mx-auto relative z-10" data-id="element-127">
          <Button showShine className="bg-gradient-to-r from-[#B76E79] to-[#9D4D60] text-white hover:shadow-[0_10px_30px_rgba(157,77,96,0.3)] py-6 text-xl tracking-widest uppercase" data-id="element-128">
            QUIERO EMPEZAR HOY <ArrowRight className="ml-2" data-id="element-129" />
          </Button>
          <p className="text-center mt-4 text-[10px] uppercase tracking-[0.2em] text-slate-400 font-bold" data-id="element-130">
            Acceso inmediato tras la compra
          </p>
        </div>
      </Section>

      {/* Methodology Section */}
      <Section className="my-20 relative" data-id="element-131">
        {/* Decorative Background Elements */}
        <div className="absolute top-1/2 left-0 -translate-y-1/2 -ml-12 opacity-10 pointer-events-none" data-id="element-132">
          <Leaf size={200} className="text-[#2D5A27] -rotate-45" data-id="element-133" />
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12 relative z-10" data-id="element-134">
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-[#2D5A27] mb-6" data-id="element-135">
            No son solo <span className="italic text-[#9D4D60]" data-id="element-136">recetas</span>
          </h3>
          <p className="text-slate-600 leading-relaxed max-w-xl mx-auto font-medium" data-id="element-137">
            La mayoría intenta copiar fórmulas sin entender el porqué.
            <span className="text-[#9D4D60]" data-id="element-138"> Cosmética Viva </span> te da los
            fundamentos para que crees con total libertad y seguridad.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative z-10" data-id="element-139">
          {[{
          title: 'Fundamentos Reales',
          text: 'Introducción a la cosmética natural y formulación consciente.'
        }, {
          title: 'Materia Prima',
          text: 'Ingredientes naturales y cómo utilizarlos correctamente.'
        }, {
          title: 'Seguridad Total',
          text: 'Conservación y seguridad de tus productos elaborados.'
        }, {
          title: 'Rostro y Cuerpo',
          text: 'Elaboración profesional de productos para piel y cuerpo.'
        }, {
          title: 'Bienestar Holístico',
          text: 'Aromaterapia y perfumes naturales con intención.'
        }, {
          title: 'Recetario Maestro',
          text: 'Un completo recetario con decenas de fórmulas listas.'
        }].map((item, i) => <div key={i} className="group bg-white/40 backdrop-blur-sm p-6 rounded-3xl border border-pink-100/50 hover:border-[#D4AF37]/30 transition-all duration-500 hover:shadow-xl hover:shadow-pink-100/20 flex gap-4 items-start" data-id="element-140">
              <div className="w-10 h-10 rounded-2xl bg-[#2D5A27]/5 flex items-center justify-center shrink-0 group-hover:bg-[#2D5A27] group-hover:text-white transition-colors duration-500" data-id="element-141">
                <Leaf size={18} data-id="element-142" />
              </div>
              <div data-id="element-143">
                <h4 className="font-bold text-[#2D5A27] text-sm md:text-base mb-1 uppercase tracking-wider" data-id="element-144">
                  {item.title}
                </h4>
                <p className="text-slate-500 text-xs md:text-sm leading-relaxed" data-id="element-145">
                  {item.text}
                </p>
              </div>
            </div>)}

          {/* Final Accent Card */}
          <div className="md:col-span-2 bg-gradient-to-r from-[#2D5A27] to-[#1a3a18] p-6 rounded-3xl text-white flex items-center justify-between group overflow-hidden relative" data-id="element-146">
            <div className="absolute top-0 right-0 opacity-10 group-hover:scale-110 transition-transform duration-700" data-id="element-147">
              <Flower2 size={120} data-id="element-148" />
            </div>
            <div className="relative z-10" data-id="element-149">
              <p className="font-serif italic text-lg md:text-xl" data-id="element-150">
                "Aprendé a formular, no solo a mezclar."
              </p>
            </div>
            <Sparkles className="text-[#D4AF37] relative z-10 animate-pulse" data-id="element-151" />
          </div>
        </div>
      </Section>

      {/* Bonus Section - Auto-scrolling Ribbon */}
      <section id="bonos" className="py-24 bg-white overflow-hidden relative pt-[49px] pb-[49px]" data-id="element-152">
        {/* Subtle background texture */}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-153">
          <div className="absolute top-0 left-0 transform -translate-x-1/2 -translate-y-1/2" data-id="element-154">
            <Flower2 size={400} className="text-[#B76E79]" data-id="element-155" />
          </div>
        </div>

        <div className="text-center px-6 relative z-10 pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-156">
          <span className="text-[10px] uppercase tracking-[0.5em] text-[#9D4D60] font-bold mb-4 block" data-id="element-157">
            Regalos por tu Confianza
          </span>
          <h3 className="text-4xl md:text-6xl font-serif font-bold text-[#2D5A27] mb-6 uppercase tracking-tight" data-id="element-158">
            8 Bonos{' '}
            <span className="italic text-[#D4AF37] font-light" data-id="element-159">Exclusivos</span>
          </h3>
          <div className="inline-flex items-center gap-3 bg-[#FDF2F2] px-6 py-2 rounded-full border border-pink-100" data-id="element-160">
            <Sparkles size={16} className="text-[#D4AF37] animate-pulse" data-id="element-161" />
            <p className="text-sm md:text-base text-[#9D4D60] font-bold uppercase tracking-widest" data-id="element-162">
              Gratis solo por hoy
            </p>
            <Sparkles size={16} className="text-[#D4AF37] animate-pulse" data-id="element-163" />
          </div>
        </div>

        <div className="max-w-2xl mx-auto px-6 space-y-12 relative z-10" data-id="element-164">
          {BONUSES.map(bonus => <motion.div key={bonus.id} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group cursor-pointer" data-id="element-165">
              <div className="relative bg-white rounded-[3rem] p-8 border border-pink-50 shadow-sm hover:shadow-2xl hover:shadow-pink-100/40 transition-all duration-500 flex flex-col md:flex-row items-center gap-8 pt-[14px] pb-[14px]" data-id="element-166">
                <div className="w-full md:w-1/2 aspect-[4/5] overflow-hidden rounded-[2.5rem] bg-[#FDF2F2]/50 flex items-center justify-center shrink-0" data-id="element-167">
                  <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-168" />
                </div>
                <div className="flex-1 text-center md:text-left" data-id="element-169">
                  <div className="flex items-center gap-2 mb-4 justify-center md:justify-start" data-id="element-170">
                    <span className="bg-[#D4AF37] text-white text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-[0.2em]" data-id="element-171">
                      Bono #{bonus.id}
                    </span>
                  </div>
                  <h4 className="text-[#2D5A27] text-3xl font-serif font-bold mb-4" data-id="element-172">
                    {bonus.title}
                  </h4>
                  <p className="text-slate-500 text-sm mb-6 leading-relaxed" data-id="element-173">
                    {bonus.description}
                  </p>
                  <div className="flex flex-col md:items-start gap-1 bg-[#FDF2F2] p-5 rounded-2xl border border-pink-50 pt-[0px] pb-[0px] mt-[0px] mb-[0px] items-center justify-center" data-id="element-174">
                    <span className="text-[11px] text-slate-400 line-through font-medium" data-id="element-175">
                      VALOR REAL: $15.000 ARS
                    </span>
                    <span className="font-black text-[#9D4D60] tracking-widest uppercase text-[12px]" data-id="element-176">
                      ¡Hoy es tuyo GRATIS!
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>

      {/* Final Convincer Section */}
      <div className="relative py-24 px-6 overflow-hidden pt-[0px] pb-[0px] mt-[0px] mb-[0px] space-y-[0px]" data-id="element-177">
        {/* Premium Background Elements */}
        <div className="absolute inset-0 bg-gradient-to-b from-white via-[#FDF2F2] to-[#FAC7C7]/30 pointer-events-none" data-id="element-178" />

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-179">
          <div className="bg-white/40 backdrop-blur-md rounded-[3rem] p-12 md:p-20 border border-white/60 shadow-[0_32px_64px_-12px_rgba(183,110,121,0.15)] text-center relative overflow-hidden group pt-[19px] pb-[19px] mt-[0px] mb-[0px] space-y-[0px]" data-id="element-180">
            {/* Subtle Animated Shine */}
            <motion.div initial={{
            x: '-100%'
          }} animate={{
            x: '200%'
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'linear',
            repeatDelay: 3
          }} className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] pointer-events-none" data-id="element-181" />

            {/* Decorative Icons */}
            <div className="absolute top-8 left-8 text-[#D4AF37]/20" data-id="element-182">
              <Sparkles size={48} data-id="element-183" />
            </div>
            <div className="absolute bottom-8 right-8 text-[#B76E79]/20" data-id="element-184">
              <Flower2 size={48} data-id="element-185" />
            </div>

            <div className="max-w-2xl mx-auto space-y-10" data-id="element-186">
              <div className="space-y-4" data-id="element-187">
                <span className="text-[10px] md:text-xs font-black uppercase tracking-[0.4em] text-[#D4AF37]" data-id="element-188">
                  Tu transformación comienza aquí
                </span>
                <h3 className="md:text-6xl font-serif font-bold text-[#2D5A27] text-[32px]" data-id="element-189">
                  Invertís una vez. <br data-id="element-190" />
                  <span className="italic text-[#9D4D60] relative inline-block" data-id="element-191">
                    Aprendés para siempre.
                    <motion.div initial={{
                    width: 0
                  }} whileInView={{
                    width: '100%'
                  }} transition={{
                    duration: 1,
                    delay: 0.5
                  }} className="absolute -bottom-2 left-0 h-[2px] bg-[#D4AF37]/30" data-id="element-192" />
                  </span>
                </h3>
              </div>

              <div className="space-y-6" data-id="element-193">
                <p className="md:text-2xl text-slate-600 font-medium text-[12px]" data-id="element-194">
                  Unite a más de{' '}
                  <span className="text-[#2D5A27] font-bold" data-id="element-195">
                    1.000 mujeres
                  </span>{' '}
                  que ya están creando su propia cosmética natural con{' '}
                  <br className="hidden md:block" data-id="element-196" />
                  <span className="text-[#2D5A27] font-bold" data-id="element-197">
                    300 recetas
                  </span>{' '}
                  y{' '}
                  <span className="text-[#2D5A27] font-bold" data-id="element-198">
                    8 bonos exclusivos
                  </span>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Purchase Section */}
      <div ref={purchaseSectionRef} className="py-24 px-6 relative overflow-hidden space-y-[33px] bg-[#FAC7C7] pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-199">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden" data-id="element-200">
          <motion.div animate={{
          rotate: 360
        }} transition={{
          duration: 50,
          repeat: Infinity,
          ease: 'linear'
        }} className="absolute -top-24 -left-24 text-[#B76E79]/10" data-id="element-201">
            <Flower2 size={400} data-id="element-202" />
          </motion.div>
          <motion.div animate={{
          y: [0, 20, 0]
        }} transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute bottom-12 -right-12 text-[#2D5A27]/10" data-id="element-203">
            <Leaf size={300} data-id="element-204" />
          </motion.div>
        </div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-205">
          {/* Offer Selection Section */}
          <div className="mb-12 space-y-6" data-id="element-206">
            <div className="text-center space-y-1" data-id="element-207">
              <p className="text-[10px] md:text-xs font-black uppercase tracking-[0.3em] text-[#2D5A27] bg-white/50 backdrop-blur-sm py-1 px-3 rounded-full w-fit mx-auto border border-[#D4AF37]/20 shadow-sm" data-id="element-208">
                ✨ Elegí la alternativa que mejor se adapte a vos
              </p>
              <h3 className="text-xl md:text-2xl font-serif font-bold text-[#2D5A27] uppercase tracking-tight" data-id="element-209">
                Comenzá a crear desde hoy
              </h3>
            </div>

            <div className="grid gap-4" data-id="element-210">
              {/* Option 1: Base Offer */}
              <motion.div whileHover={{
              scale: 1.01
            }} whileTap={{
              scale: 0.99
            }} onClick={() => setSelectedOffer('base')} className={cn('relative cursor-pointer p-6 rounded-[2.5rem] border-2 transition-all duration-300', selectedOffer === 'base' ? 'bg-white border-[#A78BFA] shadow-xl shadow-purple-100/50' : 'bg-white/60 border-transparent hover:border-purple-200')} data-id="element-211">
                <div className="flex items-start gap-4" data-id="element-212">
                  <div className={cn('mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors', selectedOffer === 'base' ? 'border-[#A78BFA] bg-[#A78BFA]' : 'border-slate-300')} data-id="element-213">
                    {selectedOffer === 'base' && <div className="w-2 h-2 rounded-full bg-white" data-id="element-214" />}
                  </div>
                  <div className="flex-1 space-y-3" data-id="element-215">
                    <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-216">
                      <h4 className="font-serif font-bold text-[#2D5A27] text-lg md:text-xl" data-id="element-217">
                        Cosmética Viva + 8 Bonos Gratuitos
                      </h4>
                      <div className="text-right" data-id="element-218">
                        <p className="text-xs line-through text-slate-400" data-id="element-219">
                          $59.990
                        </p>
                        <p className="text-xl font-bold text-[#2D5A27]" data-id="element-220">
                          $19.990
                        </p>
                      </div>
                    </div>
                    <p className="text-xs md:text-sm text-slate-500 leading-relaxed font-medium" data-id="element-221">
                      Explorá el mundo de la cosmética natural creando tus
                      propios sérums, cremas, skincare, maquillaje, protectores
                      solares y productos capilares. Una guía completa para
                      aprender desde casa, paso a paso y a tu ritmo.
                    </p>
                    <div className="flex flex-wrap gap-x-4 gap-y-1 pt-2 border-t border-slate-100" data-id="element-222">
                      {['✓ Guía Cosmética Viva', '✓ 8 Bonos Exclusivos', '✓ Acceso inmediato', '✓ Formato PDF'].map((item, i) => <span key={i} className="text-[10px] font-bold text-[#9D4D60] uppercase tracking-wider" data-id="element-223">
                          {item}
                        </span>)}
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Option 2: Premium Offer */}
              <motion.div whileHover={{
              scale: 1.01
            }} whileTap={{
              scale: 0.99
            }} onClick={() => setSelectedOffer('premium')} className={cn('relative cursor-pointer p-6 rounded-[2.5rem] border-2 transition-all duration-300', selectedOffer === 'premium' ? 'bg-white border-[#A78BFA] shadow-2xl shadow-purple-200/50' : 'bg-white/60 border-transparent hover:border-purple-200')} data-id="element-224">
                {/* Badge */}
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#D4AF37] to-[#B76E79] text-white text-[10px] font-black px-4 py-1 rounded-full shadow-lg z-20 whitespace-nowrap tracking-widest" data-id="element-225">
                  ⭐ MÁS ELEGIDO
                </div>

                <div className="flex items-start gap-4" data-id="element-226">
                  <div className={cn('mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors', selectedOffer === 'premium' ? 'border-[#A78BFA] bg-[#A78BFA]' : 'border-slate-300')} data-id="element-227">
                    {selectedOffer === 'premium' && <div className="w-2 h-2 rounded-full bg-white" data-id="element-228" />}
                  </div>
                  <div className="flex-1 space-y-3" data-id="element-229">
                    <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-230">
                      <h4 className="font-serif font-bold text-[#2D5A27] text-lg md:text-xl" data-id="element-231">
                        Pack Completo Cosmética Viva + Esencia Áurica
                      </h4>
                      <div className="text-right" data-id="element-232">
                        <p className="text-xs line-through text-slate-400" data-id="element-233">
                          $99.990
                        </p>
                        <p className="text-xl font-bold text-[#2D5A27]" data-id="element-234">
                          $29.990
                        </p>
                      </div>
                    </div>
                    <p className="text-xs md:text-sm leading-relaxed font-medium text-[#64748B]" data-id="element-235">
                      Accedé al universo completo de la creación natural.
                      Aprendé a elaborar skincare, cremas, pomadas, protector
                      solar, maquillaje y productos capilares con Cosmética
                      Viva, y además llevate Esencia Áurica una guía para crear
                      perfumes naturales, Agua Florida, brumas áuricas desde
                      casa. Hoy te llevas 2 formaciones premium y 14 bonos
                      exclusivos.
                    </p>
                    <div className="flex flex-wrap gap-x-4 gap-y-1 pt-2 border-t border-slate-100" data-id="element-236">
                      {['✓ Cosmética Viva', '✓ Esencia Áurica', '✓ 14 Bonos Exclusivos', '✓ Acceso inmediato', '✓ Formato PDF'].map((item, i) => <span key={i} className="text-[10px] font-bold text-[#9D4D60] uppercase tracking-wider" data-id="element-237">
                          {item}
                        </span>)}
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>

            <p className="text-center text-sm font-bold text-[#9D4D60] animate-pulse" data-id="element-238">
              💜 Ahorrás más de $70.000 comprando el pack completo.
            </p>
          </div>

          {/* Pricing */}
          <div className="text-center space-y-8 mb-12" data-id="element-239">
            <div className="space-y-2" data-id="element-240">
              <p className="text-xl md:text-2xl line-through text-slate-400 font-serif italic" data-id="element-241">
                Antes {selectedOffer === 'premium' ? '$99.990' : '$59.990'} ARS
              </p>
              <div className="relative inline-block" data-id="element-242">
                <p className="text-7xl md:text-9xl font-serif font-bold tracking-tighter text-[#2D5A27] drop-shadow-sm" data-id="element-243">
                  {selectedOffer === 'premium' ? '$29.990' : '$19.990'}
                  <span className="text-3xl md:text-4xl ml-2" data-id="element-244">ARS</span>
                </p>
                <div className="absolute -top-4 -right-8 bg-[#D4AF37] text-white text-[10px] font-black px-3 py-1 rounded-full shadow-lg transform rotate-12 uppercase tracking-widest" data-id="element-245">
                  {selectedOffer === 'premium' ? '70% OFF' : '66% OFF'}
                </div>
              </div>
              <p className="text-xl md:text-2xl text-[#9D4D60] font-serif font-bold italic tracking-wide" data-id="element-246">
                Pago único • Acceso de por vida
              </p>
            </div>

            <div className="inline-flex items-center gap-3 bg-white/60 backdrop-blur-sm px-8 py-4 rounded-2xl border border-[#D4AF37]/20 shadow-sm pt-[0px] pb-[0px] pl-[18px] pr-[18px] mt-[14px] mb-[14px] ml-[6px] mr-[6px]" data-id="element-247">
              <div className="w-10 h-10 rounded-full bg-[#2D5A27]/5 flex items-center justify-center text-[#2D5A27]" data-id="element-248">
                <CreditCard size={20} data-id="element-249" />
              </div>
              <span className="font-bold text-[#2D5A27] tracking-tight" data-id="element-250">
                Hasta 3 cuotas sin interés
              </span>
            </div>

            {/* Ultra-compact Urgency Bar */}
            <div className="flex flex-row items-center justify-center gap-8 py-3 px-6 bg-white/40 rounded-full border border-[#D4AF37]/10 w-fit mx-auto mt-[16px] mb-[16px] pt-[1px] pb-[1px]" data-id="element-251">
              <div className="flex items-center gap-3" data-id="element-252">
                <div className="relative flex h-2 w-2" data-id="element-253">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-254"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-255"></span>
                </div>
                <p className="text-[9px] md:text-[10px] font-black text-[#2D5A27] uppercase tracking-widest" data-id="element-256">
                  {viewers} MIRANDO
                </p>
              </div>
              <div className="w-px h-4 bg-[#D4AF37]/20" data-id="element-257" />
              <div className="flex items-center gap-3" data-id="element-258">
                <Ticket size={12} className="text-red-500" data-id="element-259" />
                <p className="text-[9px] md:text-[10px] font-black text-red-600 uppercase tracking-widest" data-id="element-260">
                  {coupons} CUPOS
                </p>
              </div>
            </div>
          </div>

          {/* Counter Block */}
          <div className="bg-white/40 backdrop-blur-sm rounded-3xl p-4 text-center border border-pink-100 shadow-inner max-w-sm mx-auto pt-[0px] pb-[0px] mt-[24px] mb-[24px]" data-id="element-261">
            <div className="flex items-center justify-center gap-2 mb-1" data-id="element-262">
              <Users size={16} className="text-[#D4AF37]" data-id="element-263" />
              <p className="text-3xl font-serif font-bold text-[#2D5A27]" data-id="element-264">
                {studentCount.toLocaleString('de-DE')}
              </p>
            </div>
            <p className="text-[9px] font-black uppercase tracking-[0.2em] text-[#9D4D60]" data-id="element-265">
              ALUMNAS YA ADQUIRIERON SU GUÍA
            </p>
          </div>

          {/* Countdown Timer Bar */}
          <div className="max-w-md mx-auto mb-6 px-2" data-id="element-266">
            <div className="flex items-center justify-between mb-2" data-id="element-267">
              <span className="text-[10px] font-black uppercase tracking-[0.2em] text-[#9D4D60]" data-id="element-268">
                La oferta termina en:
              </span>
              <CountdownText data-id="element-269" />
            </div>
            <div className="h-2 w-full bg-white/40 rounded-full overflow-hidden border border-pink-100 shadow-inner" data-id="element-270">
              <motion.div initial={{
              width: '100%'
            }} animate={{
              width: '0%'
            }} transition={{
              duration: 600,
              ease: 'linear'
            }} className="h-full bg-gradient-to-r from-[#B76E79] to-[#9D4D60]" data-id="element-271" />
            </div>
          </div>

          {/* CTA Button */}
          <div className="relative group mb-10 max-w-xl mx-auto" data-id="element-272">
            <div className="absolute -inset-1.5 bg-gradient-to-r from-[#B76E79] via-[#D4AF37] to-[#9D4D60] rounded-full blur-md opacity-30 group-hover:opacity-60 transition duration-1000 group-hover:duration-200" data-id="element-273"></div>
            <Button showShine onClick={() => {
            const url = selectedOffer === 'premium' ? 'https://novalibros.shop/cart/48530262917369:1' : 'https://novalibros.shop/cart/48530262130937:1';
            window.location.href = url;
          }} className="relative bg-gradient-to-r from-[#B76E79] via-[#9D4D60] to-[#B76E79] bg-[length:200%_auto] hover:bg-right transition-all duration-500 text-white text-xl md:text-2xl py-8 rounded-full border-2 border-white/30 shadow-[0_15px_40px_rgba(157,77,96,0.4)] tracking-[0.1em] overflow-hidden" data-id="element-274">
              <Sparkles className="w-5 h-5 md:w-6 md:h-6 animate-pulse text-white/80" data-id="element-275" />
              <span className="px-2" data-id="element-276">
                {selectedOffer === 'premium' ? 'SÍ, QUIERO EL PACK COMPLETO' : 'SÍ, QUIERO MI GUIA AHORA'}
              </span>
              <ArrowRight className="w-6 h-6 md:w-8 md:h-8 group-hover:translate-x-1 transition-transform" data-id="element-277" />
            </Button>
          </div>

          {/* MercadoLíder Trust Section */}
          <div className="bg-white/80 backdrop-blur-sm border border-slate-100 rounded-2xl p-5 mb-10 shadow-sm max-w-md mx-auto text-left" data-id="element-278">
            <div className="flex items-center gap-3 mb-4" data-id="element-279">
              <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center text-green-600 shrink-0" data-id="element-280">
                <Medal size={20} data-id="element-281" />
              </div>
              <div data-id="element-282">
                <h4 className="text-green-600 font-bold text-sm leading-tight" data-id="element-283">
                  MercadoLíder Platinum
                </h4>
                <p className="text-slate-400 text-[10px] font-medium" data-id="element-284">
                  ¡Es uno de los mejores del sitio!
                </p>
              </div>
            </div>

            <div className="grid grid-cols-5 gap-1 mb-5" data-id="element-285">
              <div className="h-1 rounded-full bg-[#FFF1F1]" data-id="element-286" />
              <div className="h-1 rounded-full bg-[#FFF1F1]" data-id="element-287" />
              <div className="h-1 rounded-full bg-[#FFF1F1]" data-id="element-288" />
              <div className="h-1 rounded-full bg-green-200" data-id="element-289" />
              <div className="h-1 rounded-full bg-green-500" data-id="element-290" />
            </div>

            <div className="mb-5" data-id="element-291">
              <p className="text-xl font-bold text-slate-800" data-id="element-292">1010</p>
              <p className="text-[10px] text-slate-400 font-medium" data-id="element-293">
                Ventas en los últimos 60 días
              </p>
            </div>

            <div className="space-y-2.5 pt-4 border-t border-slate-50" data-id="element-294">
              <div className="flex items-center gap-3" data-id="element-295">
                <MessageCircle size={14} className="text-green-500" data-id="element-296" />
                <p className="text-[11px] font-medium text-slate-600" data-id="element-297">
                  Brinda buena atención
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-298">
                <Zap size={14} className="text-green-500" data-id="element-299" />
                <p className="text-[11px] font-medium text-slate-600" data-id="element-300">
                  Despacha sus productos a tiempo
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-301">
                <ShieldCheck size={14} className="text-[#D4AF37]" data-id="element-302" />
                <p className="text-[11px] font-bold text-slate-800" data-id="element-303">
                  Compra 100% Segura
                </p>
              </div>
            </div>
          </div>

          {/* Trust Badges */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center justify-items-center mb-10 opacity-90" data-id="element-304">
            <img src="https://cdn.magicpatterns.com/uploads/2esg8TZ8XPcPzVZ7uhJqsN/pasted-image.png" alt="Compra Segura" className="h-14 md:h-16 object-contain" data-id="element-305" />
            <img src="https://cdn.magicpatterns.com/uploads/wokS51Pt6mAkbEbb1iBzyx/pasted-image.png" alt="Pago Seguro Garantizado" className="h-14 md:h-16 object-contain" data-id="element-306" />
          </div>
        </div>
      </div>

      {/* Testimonials & Comments */}
      <Section className="bg-white rounded-t-[3rem] -mt-12 relative z-10" data-id="element-307">
        <div className="text-center mb-12" data-id="element-308">
          <h3 className="text-3xl font-serif font-bold text-[#2D5A27] mb-2" data-id="element-309">
            Lo que dicen nuestras alumnas
          </h3>
          <div className="flex justify-center gap-1 text-[#D4AF37]" data-id="element-310">
            {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" data-id="element-311" />)}
          </div>
        </div>

        {/* Comment Input */}
        <div className="bg-[#FDF2F2] p-8 rounded-3xl mb-12 border border-pink-100" data-id="element-312">
          <h4 className="font-bold mb-4 text-lg" data-id="element-313">Dejá tu reseña</h4>
          <div className="flex gap-2 mb-4" data-id="element-314">
            {[1, 2, 3, 4, 5].map(star => <button key={star} onClick={() => setNewRating(star)} data-id="element-315">
                <Star className={`w-6 h-6 ${star <= newRating ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-slate-300'}`} data-id="element-316" />
              </button>)}
          </div>
          <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Escribí tu experiencia aquí..." className="w-full p-4 rounded-xl border border-slate-200 focus:ring-2 focus:ring-[#2D5A27] focus:border-transparent outline-none min-h-[120px] mb-4" data-id="element-317" />
          <button onClick={handlePostComment} className="bg-[#2D5A27] text-white px-8 py-3 rounded-xl font-bold hover:bg-[#1a3a18] transition-colors" data-id="element-318">
            Publicar
          </button>
        </div>

        {/* Comments List */}
        <div className="space-y-6" data-id="element-319">
          {comments.slice(0, visibleComments).map(comment => <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} key={comment.id} className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-320">
              <div className="flex items-center gap-4 mb-4" data-id="element-321">
                {comment.avatar ? <img src={comment.avatar} alt={comment.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#2D5A27]/10" data-id="element-322" /> : <div className="w-12 h-12 rounded-full bg-[#2D5A27]/10 flex items-center justify-center text-[#2D5A27] font-bold text-xl" data-id="element-323">
                    {comment.name[0]}
                  </div>}
                <div data-id="element-324">
                  <div className="flex items-center gap-2" data-id="element-325">
                    <p className="font-bold" data-id="element-326">{comment.name}</p>
                    <span className="text-xs text-slate-400" data-id="element-327">
                      • {comment.date}
                    </span>
                  </div>
                  <div className="flex gap-0.5" data-id="element-328">
                    {[...Array(5)].map((_, i) => <Star key={i} className={`w-3 h-3 ${i < comment.rating ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-slate-200'}`} data-id="element-329" />)}
                  </div>
                </div>
              </div>
              <p className="text-slate-600 leading-relaxed mb-4" data-id="element-330">
                {comment.text}
              </p>
              <button className="flex items-center gap-2 text-sm font-medium text-slate-400 hover:text-[#2D5A27] transition-colors" data-id="element-331">
                <ThumbsUp className="w-4 h-4" data-id="element-332" /> {comment.likes}
              </button>
            </motion.div>)}
        </div>

        {visibleComments < 30 && <div className="text-center mt-12" data-id="element-333">
            <button onClick={() => setVisibleComments(prev => Math.min(prev + 5, 35))} className="text-[#2D5A27] font-bold border-2 border-[#2D5A27] px-8 py-3 rounded-xl hover:bg-[#2D5A27] hover:text-white transition-all" data-id="element-334">
              Cargar 5 comentarios más
            </button>
          </div>}
      </Section>

      {/* Footer */}
      <footer className="text-white py-12 px-6 text-center bg-[#4D384D] pt-[41px] pb-[41px] mt-[47px] mb-[47px]" data-id="element-335">
        <p className="text-sm opacity-50 mb-4" data-id="element-336">
          © 2026 Cosmética Viva - Todos los derechos reservados
        </p>
        <p className="text-xs opacity-30 max-w-xl mx-auto" data-id="element-337">
          Este producto no sustituye el asesoramiento profesional. Siempre
          consulte a su médico o dermatólogo antes de aplicar nuevos productos
          en su piel.
        </p>
      </footer>

      {/* Sticky Bar */}
      <AnimatePresence data-id="element-338">
        {showSticky && <motion.div initial={{
        y: -100,
        x: '-50%',
        opacity: 0
      }} animate={{
        y: 0,
        x: '-50%',
        opacity: 1
      }} exit={{
        y: -100,
        x: '-50%',
        opacity: 0
      }} className="fixed top-6 left-1/2 z-[90] w-[90%] max-w-md" data-id="element-339">
            <div className="bg-white/60 backdrop-blur-xl border border-white/40 shadow-[0_8px_32px_rgba(157,77,96,0.15)] rounded-full px-6 py-2 flex items-center justify-between gap-4 pt-[0px] pb-[0px]" data-id="element-340">
              <div className="flex items-center gap-2 overflow-hidden h-5" data-id="element-341">
                <AnimatePresence mode="wait" data-id="element-342">
                  <motion.div key={stickyInfoIndex} initial={{
                y: 20,
                opacity: 0
              }} animate={{
                y: 0,
                opacity: 1
              }} exit={{
                y: -20,
                opacity: 0
              }} transition={{
                duration: 0.5
              }} className="flex items-center gap-2" data-id="element-343">
                    <div className={cn('w-2 h-2 rounded-full animate-pulse', stickyInfoIndex === 0 ? 'bg-green-500' : 'bg-red-500')} data-id="element-344" />
                    <span className="md:text-xs font-bold text-[#9D4D60] uppercase tracking-widest whitespace-nowrap text-[7px]" data-id="element-345">
                      {stickyInfoIndex === 0 ? `${viewers} personas mirando` : `¡Solo quedan ${coupons} cupos!`}
                    </span>
                  </motion.div>
                </AnimatePresence>
              </div>
              <button onClick={scrollToPurchase} className="bg-gradient-to-r from-[#B76E79] to-[#9D4D60] text-white text-[10px] md:text-xs font-black px-5 py-2 rounded-full shadow-md hover:scale-105 active:scale-95 transition-all uppercase tracking-tighter flex items-center gap-1" data-id="element-346">
                Ver Oferta
                <ArrowRight size={12} data-id="element-347" />
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Modals & Notifications */}
      <AnimatePresence data-id="element-348">
        {purchaseNotify && <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -50
      }} className="fixed bottom-6 left-6 z-[100] bg-white/70 backdrop-blur-md p-3 rounded-2xl shadow-xl border border-white/40 flex items-center gap-3 max-w-[240px]" data-id="element-349">
            <div className="w-8 h-8 bg-[#FDF2F2] rounded-full flex items-center justify-center text-sm shadow-inner shrink-0" data-id="element-350">
              💄
            </div>
            <div className="min-w-0" data-id="element-351">
              <p className="text-[11px] font-bold text-[#9D4D60] leading-tight truncate" data-id="element-352">
                {purchaseNotify.name} de {purchaseNotify.city}
              </p>
              <p className="text-[10px] text-slate-500 leading-tight" data-id="element-353">
                Adquirió Cosmética Viva
              </p>
            </div>
          </motion.div>}

        {showSuccessModal && <div className="fixed inset-0 z-[200] flex items-center justify-center p-6 bg-black/60 backdrop-blur-sm" data-id="element-354">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} className="bg-white p-8 rounded-[2rem] max-w-sm w-full text-center shadow-2xl" data-id="element-355">
              <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-356">
                <MessageCircle size={40} data-id="element-357" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-358">
                ¡Gracias por tu comentario!
              </h3>
              <p className="text-slate-600 mb-8" data-id="element-359">
                Tu opinión ayuda a la comunidad.
              </p>
              <button onClick={() => setShowSuccessModal(false)} className="w-full bg-[#2D5A27] text-white py-4 rounded-xl font-bold" data-id="element-360">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </div>;
}